import {
  DEFAULT_DATA_POINT_RADIUS,
  DEFAULT_FILL_OPACITY,
} from '../../../../constants.js';
import {
  FnCanvasAccessor,
  type DotCanvasInstance,
} from '../../types/canvas-shape.js';
import { getCanvasColor } from '../canvas-color.js';
import { drawSymbol, type CanvasShapeType } from './symbol-canvas.js';

type FnDotCanvasStyle<Datum> = (
  ctx: CanvasRenderingContext2D,
  dotCanvas: DotCanvasInstance<Datum>,
  x: FnCanvasAccessor<Datum>,
  y: FnCanvasAccessor<Datum>,
) => void;

/**
 * Builds style FN Dot based on parameters.
 *
 * @param radius - scatter plot radius
 * @returns - fn print Line canvas
 */
export function printDotBuilder<Datum>(
  radius: number = DEFAULT_DATA_POINT_RADIUS,
  shape?: CanvasShapeType,
): FnDotCanvasStyle<Datum> {
  return (ctx, dotCanvas, x, y) => {
    const {
      color,
      data,
      opacity = DEFAULT_FILL_OPACITY,
      defined = () => true,
    } = dotCanvas;

    const dotColor = getCanvasColor(color(data[0]));

    ctx.save();
    ctx.globalAlpha = opacity;
    ctx.globalCompositeOperation = 'multiply';
    ctx.fillStyle = dotColor;
    ctx.filter = 'none';

    const dataLength = data.length;
    ctx.beginPath();

    for (let i = 0; i < dataLength; i++) {
      if (
        !defined(data[i]) ||
        y(data[i], i) > dotCanvas.canvasHeight ||
        y(data[i], i) < 0 ||
        x(data[i], i) > dotCanvas.canvasWidth ||
        x(data[i], i) < 0
      ) {
        continue;
      }
      const cx = x(data[i], i);
      const cy = y(data[i], i);

      ctx.moveTo(cx, cy);
      drawSymbol(ctx, cx, cy, radius, shape);
    }
    ctx.closePath();
    ctx.fill();

    ctx.restore();
  };
}
